import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { captureException } from '../utils/sentry';
import { getEndTimeLocalStorageKey } from '../utils/utils';
import { clearLocalStorageExcept } from '../utils/helperFunction';
import { PROCTOR_NEXT_IMAGE_SEQUENCE_LOCALSTORAGE_KEY } from '../constants/Proctor';

export default (state = initialState.test, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_TEST}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    case `${ActionTypes.START_TEST}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    case `${ActionTypes.GET_FEEDBACK}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    case `${ActionTypes.GET_FEEDBACK}_FAIL`: {
      return _assign({}, state, { feedback: false });
    }
    case `${ActionTypes.WAIT_TILL_VIDEO_SUBMIT}_SUCCESS`: {
      return { ...state, waitTillVideoSubmit: true };
    }
    case `${ActionTypes.WAIT_TILL_VIDEO_SUBMIT}_FAIL`: {
      return { ...state, waitTillVideoSubmit: false };
    }
    case ActionTypes.SET_CURRENTLY_PLAYING_AUDIO_PROLEM_SLUG: {
      return { ...state, currentlyPlayingAudioSlug: action.payload };
    }
    case ActionTypes.SET_AUDIO_PLAY_COUNT: {
      return { ...state, audioPlayCountObj: action.payload };
    }
    case ActionTypes.SET_TEST_LIVE_STATUS: {
      return { ...state, is_live: action.payload.testLiveStatus };
    }
    case ActionTypes.CLEAR_LOCAL_DATA: {
      try {
        if (action.isTestStart)
          clearLocalStorageExcept(PROCTOR_NEXT_IMAGE_SEQUENCE_LOCALSTORAGE_KEY);
        else localStorage.clear();
      } catch (localStorageError) {
        captureException(localStorageError);
      }
      return state;
    }
    case ActionTypes.SET_PROCTOR_IS_TEST_SUBMITTED: {
      return {
        ...state,
        isTestSubmitted: action.payload,
      };
    }
    case ActionTypes.UPADTE_TEST_EXPIRY_AND_TEST_SESSION: {
      const { is_expired, session_state } = action;
      let updatedData = {};
      // to avoid unrequired re-rendering, only pased value being considered
      if (is_expired) {
        updatedData = {
          ...updatedData,
          is_expired,
        };
      }
      if (session_state) {
        updatedData = {
          ...updatedData,
          session_state,
        };
      }
      return {
        ...state,
        ...updatedData,
      };
    }
    case ActionTypes.SET_TEST_SUBMIT_IN_PROCESS: {
      return {
        ...state,
        isTestSubmitInProcess: action.payload,
      };
    }
    case ActionTypes.SET_TEST_END_TIME: {
      const testEndTimeKey = getEndTimeLocalStorageKey(
        action.payload.assessmentId
      );
      let cachedTestEndTime = localStorage.getItem(testEndTimeKey);
      if (!cachedTestEndTime) {
        localStorage.setItem(testEndTimeKey, action.payload.currentTestEndTime);
        cachedTestEndTime = action.payload.currentTestEndTime;
      }
      return {
        ...state,
        testEndTime: cachedTestEndTime,
      };
    }
    case ActionTypes.SET_VIDEO_UPLOAD_STATUS: {
      const { problemSlug, isUploadInProgress } = action;
      return {
        ...state,
        isUploadInProgress: {
          ...state.isUploadInProgress,
          [problemSlug]: isUploadInProgress,
        },
      };
    }
    case ActionTypes.SET_VIDEO_UPLOAD_FAILED: {
      const { problemSlug, isVideoUploadFailed } = action;
      return {
        ...state,
        isVideoUploadFailed: {
          ...state.isVideoUploadFailed,
          [problemSlug]: isVideoUploadFailed,
        },
      };
    }
    case ActionTypes.SET_AUDIO_UPLOAD_STATUS: {
      const { problemSlug, isAudioUploadInProgress } = action;
      return {
        ...state,
        isAudioUploadInProgress: {
          ...state.isAudioUploadInProgress,
          [problemSlug]: isAudioUploadInProgress,
        },
      };
    }
    case ActionTypes.SET_TEST_SUBMITTING: {
      return {
        ...state,
        isTestSubmitting: action.payload,
      };
    }
    case ActionTypes.SECURE_BROWSER_STATUS: {
      return {
        ...state,
        isSecureBrowserEnable: action.payload,
      };
    }
    default:
      return state;
  }
};
